import React from 'react'
import ScratchCard from 'react-scratchcard-v4'
import styled from 'styled-components'
import TryAgainBackground from '../../assets/abf/tryagain.jpg'
import WinnerBackground from '../../assets/abf/winner.jpg'
import ScratchImage from '../../assets/img/scratch-to-win-custom.png'
import { ScratchContent, Scratchpad } from './styled'

const settings = {
  width: 550,
  height: 550,
  image: ScratchImage,
  finishPercent: 70,
  // backgroundColor: '#ffc706',
  // onComplete: () => console.log("The card is now clear!"),
};

interface ScratchProps {
  winner: boolean;
  number: number;
}

const WinnerContent = styled.div`
  width: 100%;
  height: 100%;
  border: 2px solid var(--text-color-light);
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${WinnerBackground});
  background-size: cover;
  /* Estilos adicionais para o conteúdo vencedor */
`;

const TryAgainContent = styled.div`
  width: 100%;
  height: 100%;
  border: 2px solid var(--text-color-light);
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${TryAgainBackground});
  background-size: cover;
  /* Estilos adicionais para o conteúdo de tentar novamente */
`;

const Scratch: React.FC<ScratchProps> = ({ winner, number }) => {
  return (
  <>
    {/* <ScratchContainer> */}
      <ScratchContent>
        <Scratchpad>
          {winner ? (
            <ScratchCard {...settings} key={number}>
              <WinnerContent></WinnerContent>
              <div style={{
                  marginTop: '-50px',
                  marginRight: '50px',
                  color: 'black',
                  zIndex: '-999',
                  width: '90%',
                  textAlign: 'right'
                }}>Nº {number / 8}</div>
            </ScratchCard>
          ) : (
            <ScratchCard {...settings} key={number}>
                <TryAgainContent></TryAgainContent>  
            </ScratchCard>
          )}
        </Scratchpad>
      </ScratchContent>
    {/* </ScratchContainer> */}
  </>
  );
};

export default Scratch;
